import jsPDF from 'jspdf';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import imagenMembrete from '../assets/images/membrete.jpg';

const capitalizarTexto = (text) => text
    .toLowerCase() // primero todo en minúsculas
    .split(' ') // dividir en palabras
    .map(palabra =>
        palabra.charAt(0).toUpperCase() + palabra.slice(1)
    )
    .join(' '); // unir de nuevo

const numToLetter = (num) => String.fromCharCode(96 + num)

export const generarCartaCompromiso = (proceso, { carnet, nombres, primerApellido, segundoApellido, carrera, documentos }) => {
    // Inicializar documento
    const doc = new jsPDF({
        unit: 'cm',
        format: 'A4',
        orientation: 'portrait',
    })

    const nombreEstudiante = `${nombres} ${primerApellido} ${segundoApellido}`
    const fechaActual = format(new Date(), "'a los' d 'dias del mes de' MMMM 'del año' yyyy", { locale: es });
    const fechaFinalCartaCompromiso = format(new Date(2026, 6, 31), "eeee dd 'de' MMMM 'de' yyyy", { locale: es }) // viernes 31 de julio de 2026
    const fechaFinalTituloBachiller = format(new Date(2026, 6, 31), "eeee dd 'de' MMMM 'de' yyyy", { locale: es }) // viernes 31 de julio de 2026


    // Establecer altura en cms
    let altura = 0

    // Agregar la imagen del membrete en la parte superior
    const membrete = new Image();
    membrete.src = imagenMembrete;
    doc.addImage(membrete, 'JPEG', 0, altura, 21, 6.85);

    // Establecer tipo de fuente y tamaño
    doc.setFontSize(12);
    doc.setFontType('bold');
    doc.setFont('Helvetica');

    altura += 4.4 //* Incrementar la altura en 4.4 cms para la siguiente línea
    doc.text('DECLARACIÓN JURADA DE COMPROMISO DE ENTREGA DE DOCUMENTACIÓN', 10.5, altura, { align: 'center' })

    altura += 0.8 //* Incrementar la altura en 0.8 cms para la siguiente línea
    doc.text(proceso, 10.5, altura, { align: 'center' })

    altura += 0.9 //* Incrementar la altura en 0.9 cms para la siguiente línea
    doc.setDrawColor(239, 137, 3); // Establece el color de dibujado a naranja
    doc.setLineWidth(0.02) // Establece el grosor de la línea 
    doc.line(1.5, altura, 19.5, altura); // Dibuja una línea horizontal
    doc.setDrawColor(0, 0, 0); // Vuelve a establecer color de dibujado a negro

    // Establecer nuevo tipo de fuente
    doc.setFont('Times New Roman');

    altura += 1.3 //* Incrementar la altura en 1.3 cms para la siguiente línea
    doc.setFontType('bold');
    doc.text('Carnet:', 1.5, altura, { align: 'left' })
    doc.setFontType('normal');
    doc.text(carnet, 3.5, altura, { align: 'left' })

    altura += 0.8 //* Incrementar la altura en 0.8 cms para la siguiente línea
    doc.setFontType('bold');
    doc.text('Nombres:', 1.5, altura, { align: 'left' })
    doc.setFontType('normal');
    doc.text(nombres, 3.5, altura, { align: 'left' })

    altura += 0.8 //* Incrementar la altura en 0.8 cms para la siguiente línea
    doc.setFontType('bold');
    doc.text('Apellidos:', 1.5, altura, { align: 'left' })
    doc.setFontType('normal');
    doc.text(`${primerApellido} ${segundoApellido}`, 3.5, altura, { align: 'left' })

    altura += 0.8 //* Incrementar la altura en 0.8 cms para la siguiente línea
    doc.setFontType('bold');
    doc.text('Carrera:', 1.5, altura, { align: 'left' })
    doc.setFontType('normal');
    doc.text(carrera, 3.5, altura, { align: 'left' })

    altura += 1.3 //* Incrementar la altura en 1.3 cms para la siguiente línea
    doc.setFontType('normal');
    const clausulaI = `<p style="line-height: 1.3">Yo, ${capitalizarTexto(nombreEstudiante)}, ___ años de edad, 
con Documento Único de Identidad (DUI) número __________________, en mi calidad de estudiante admitido 
en la <b>Universidad Francisco Gavidia</b>, bajo juramento <b>DECLARO</b>: 
I) Que me comprometo a presentar en tiempo y forma, a más tardar el <b>${fechaFinalCartaCompromiso}</b>, 
la documentación complementaria requerida para completar mi expediente académico, documentos que consisten en:</p>`

    const alturaEspecial = altura - 1 //! Ajuste especial para clausulaI por el formato HTML
    doc.fromHTML(clausulaI, 1.5, alturaEspecial, { width: 18.5 })

    altura += 3.4 //* Incrementar la altura en 3.4 cms para la siguiente línea    
    let numDoc = 1
    documentos.forEach((item, idx) => {
        let mostrarDocumento = item.Activo && item.Requerido && !['CARTA COMPROMISO', 'DUI', 'NIT', 'PRUEBA DE ORIENTACIÓN VOCACIONAL'].includes(item.NombreDocumentoPendiente);

        //! Nota: Medida desesperada para quitar título de bachiller de la lista y agregarlo más abajo con una fecha de entrega diferente definida en la carta compromiso
        if (item.NombreDocumentoPendiente === 'TÍTULO DE BACHILLER') mostrarDocumento = false

        if (mostrarDocumento) {
            doc.text(`${numToLetter(numDoc)}) ${item.NombreDocumentoPendiente}`, 2, altura)
            altura += 0.7
            numDoc++
        }
    });

    altura += 0.5 //* Incrementar la altura en 0.5 cms para la siguiente línea
    const clausulaAgregadaTituloBachiller = `<div style="line-height: 1.3">Y a más tardar el <b>${fechaFinalTituloBachiller}</b>, 
para el <b>TÍTULO DE BACHILLER</b> considerando los posibles retrasos en su emisión por parte del MINEDUCYT.</div>`

    const alturaEspecialII = altura - 1 //! Ajuste especial para clausulaAgregadaTituloBachiller por el formato HTML
    doc.fromHTML(clausulaAgregadaTituloBachiller, 1.5, alturaEspecialII, { width: 18.5 })

    altura += 1 //* Incrementar la altura en 1 cms para la siguiente línea
    const clausulaII = `II) Que conozco que, de conformidad con lo establecido en el Artículo 14 de la Ley de Educación Superior, 
son requisitos indispensables para iniciar estudios universitarios haber obtenido el título de bachiller 
o su equivalente legalmente reconocido en el país, y cumplir con los requisitos de admisión de la institución de educación superior. 
III) Que, por tanto, me someto a lo dispuesto en la normativa legal antes citada y en los estatutos 
y reglamentos internos de la Universidad Francisco Gavidia, aceptando que la entrega incompleta o extemporánea 
de la documentación puede afectar la validez de mi inscripción o mi condición de estudiante regular. 
IV) Que, asimismo, reconozco y acepto expresamente que, en caso o supuesto de desistimiento o retiro de la Universidad, 
y habiéndose efectuado pagos, procederá la devolución de acuerdo con la normativa legal vigente. En fe de lo anterior, 
firmo la presente Declaración Jurada en el Distrito de San Salvador, Municipio de San Salvador Centro, Departamento de San Salvador, ${fechaActual}.`
    doc.text(clausulaII, 1.5, altura, { align: 'left', maxWidth: 18.5, lineHeightFactor: 1.3 })

    altura += 6.8 //* Incrementar la altura en 5 cms para la siguiente línea
    doc.text('F.______________________________', 1.5, altura, { align: 'left' })

    altura += 0.8 //* Incrementar la altura en 0.8 cms para la siguiente línea
    doc.text(nombreEstudiante, 1.5, altura, { align: 'left' })

    altura += 1.5 //* Incrementar la altura en 0.8 cms para la siguiente línea
    doc.text('DUI: _____________________________', 1.5, altura, { align: 'left' })

    doc.save(`Declaracion_Jurada_${carnet}.pdf`);
};